import styled from 'styled-components'
import {spacing} from '../../theme/spacing'

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${spacing(4)};
    padding-top: 3.75rem;
`
